import InView from './InView';
import Glide, { Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'

export default class Lovers extends InView {

	/**
	 * @param {HTMLElement} element
	 * @param {Object} data
	 */
	constructor(element, data) {
		super(element, data);

		this.photos = this.el.querySelector(data.photos);
		this.abouts = this.el.querySelector(data.abouts);
	}

	onTopThreshold() {
		if (!this.initialized) {
			this.initialized = true;
			this.init();
		}
	}

	init() {
		// For build size reduction, it's not used full Glide lib
		const glideComponents = {Breakpoints, Swipe};

		// Photos
		this.photosSlider = new Glide(this.photos, {
			type: 'carousel',
			perView: 9,
			focusAt: 'center',
			gap: 0,
			breakpoints: {
				1600: {
					perView: 7,
				},
				1370: {
					perView: 5,
				},
				1020: {
					perView: 3,
				},
				700: {
					perView: 1,
				},
			},
		});

		// Abouts
		this.aboutsSlider = new Glide(this.abouts, {
			type: 'carousel',
			perView: 1,
			focusAt: 'center',
			gap: 0,
		});

		// Connect sliders together
		this.photosSlider.on('run', (m) => this.aboutsSlider.go(`${m.direction }${m.steps}`));
		this.aboutsSlider.on('run', (m) => this.photosSlider.go(`${m.direction }${m.steps}`));

		// Slide on click to photo
		this.photosSlider.on('build.after', () => {
			const photoItems = Array.from(this.photos.querySelectorAll('.glide__slide'));
			photoItems.forEach((item, index) => {
				item.dataset.index = index.toString();
				this.addEventListener(item, 'click', (e) => this.onPhotoClick(item, e))
			});
		});

		// Init sliders
		this.photosSlider.mount(glideComponents);
		this.aboutsSlider.mount(glideComponents);


		// Show
		this.el.classList.add('is-visible');
	}

	onPhotoClick(clickedItem, e) {
		e.preventDefault();
		e.stopPropagation();
		const activeItem = this.photos.querySelector('.glide__slide--active');
		const steps = parseInt(activeItem.dataset.index) - parseInt(clickedItem.dataset.index);
		if (steps !== 0) {
			this.photosSlider.go(steps > 0 ? '<1' : '>-1');
		}
	}
}
